import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseResponse } from '../models/rest/baseResponse';

export interface IEmbedTokenResponse extends BaseResponse {
  EmbedToken: string;
}

@Injectable({ providedIn: 'root' })
export class PowerBiService {

  constructor(private _httpClient: HttpClient) {}

  getDashboardEmbedToken(tenantId: string, groupId: string,
                         clientId: string, dashboardId: string): Observable<IEmbedTokenResponse> {
    const requestUrl = `Reports/PowerBi/EmbedToken?TenantId=${tenantId}&GroupId=${groupId}&ReportId=${dashboardId}&ClientId=${clientId}&ReportType=Dashboards`;
    return this._httpClient.get<IEmbedTokenResponse>(requestUrl);
  }

  getReportEmbedToken(tenantId: string, groupId: string,
                      clientId: string, reportId: string,
                      RLSEnabled: boolean, userAuthId?: string): Observable<IEmbedTokenResponse> {
    let requestUrl = '';
    if (RLSEnabled) {
      requestUrl = `Reports/PowerBi/EmbedToken/Rls?TenantId=${tenantId}&GroupId=${groupId}&ReportId=${reportId}&ClientId=${clientId}&ReportType=Reports&RlsUserAuthId=${userAuthId ? userAuthId : ''}&RlsRole=Default`;
    } else {
      requestUrl = `Reports/PowerBi/EmbedToken?TenantId=${tenantId}&GroupId=${groupId}&ReportId=${reportId}&ClientId=${clientId}&ReportType=Reports`;
    }

    return this._httpClient.get<IEmbedTokenResponse>(requestUrl);
  }

}
